(function () {
    'use strict';

    angular
        .module('salesflare.components.restrictedDialog', [])
        .factory('sfRestrictedDialog', sfRestrictedDialog);

    function sfRestrictedDialog($mdDialog, $state, $interval, me, model) {

        let showing = false;
        let pollInterval;

        return {
            check,
            hide,
            isShowing
        };

        function pollMe() {
            return me.get().then(function (response) {

                if (!response || !response.data) {
                    return;
                }

                Object.assign(model.me, response.data);

                if (showing && !model.me.restricted) {
                    stopPolling();
                    return hide();
                }
            });
        }

        function stopPolling() {

            if (pollInterval) {
                $interval.cancel(pollInterval);
                pollInterval = undefined;
            }
        }

        function check(state = $state) {

            // Never show the restricted dialog in settings
            // The SCA flow would avoid the routing logic, making the dialog show up anyway
            if (!state.name || state.name.includes('settings')) {
                return;
            }

            if (!showing && model.me && model.me.restricted) {
                showing = true;
                pollInterval = $interval(pollMe, 5 * 1000);

                return $mdDialog.show({
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    templateUrl: 'app-ajs/components/restricteddialog/restricteddialog.html',
                    controller: 'RestrictedDialogController'
                }).finally(function () {

                    showing = false;
                    stopPolling();
                });
            }
        }

        function hide() {

            if (showing) {
                stopPolling();
                return $mdDialog.hide();
            }
        }

        function isShowing() {

            return showing;
        }
    }
})();
